<template lang="pug">
transition(
  v-on:enter="enter"
  v-on:leave="leave"
  )
  .ending(:class="{'active': active}")
    .bg(ref="bg")
      .shadow(ref="shadow")
      .photos
        img.photo.photo-1(ref="photo1" v-if="gallery.length>0" :src="gallery[0][0]")
        img.photo.photo-2(ref="photo2" v-if="gallery.length>1" :src="gallery[1][0]")

    .copy(ref="copy" v-if="!sceneComplete")
      .line-1 滑得再慢一点
      .line-2 所见更多一些
      waveline

    .btns(ref="btns")
      .button.follow(@click="btnFollow" ref="btnFollow")
        svg.frame(width="100%" viewBox="0 0 130 20" xmlns="http://www.w3.org/2000/svg")
          rect(:x="`${56-timeline*55}`" y="1" :width="`${18+timeline*110}`" height="18" rx="9" ry="9" fill="#3a54a2" stroke="white" stroke-width="1")
        .content(:style="`transform: translate3d(${-250*timeline}%, 0, 0);`")
          svg.icon.i-follow
            use(xlink:href="#icon-follow")
          .cp
            .line(:style="`transform: translate3d(${-100*(1-timeline)}%, 0, 0);`") 关注我们
      .button.replay(@click="reset" ref="btnRestart")
        svg.frame(width="100%" viewBox="0 0 130 20" xmlns="http://www.w3.org/2000/svg")
          rect(:x="`${56-timeline2*55}`" y="1" :width="`${18+timeline2*110}`" height="18" rx="9" ry="9" fill="#3a54a2" stroke="white" stroke-width="1")
        .content(:style="`transform: translate3d(${-250*timeline2}%, 0, 0);`")
          svg.icon.i-replay
            use(xlink:href="#icon-replay")
          .cp
            .line(:style="`transform: translate3d(${-100*(1-timeline2)}%, 0, 0);`") 重新开始




</template>
<script>
import * as THREE from 'three'
import { Swiper } from 'swiper/dist/js/swiper.esm.js'
import AnalyticsService from '@/services/AnalyticsService'
import {mapState, mapMutations} from 'vuex'
import {TweenMax, TimelineMax, Power2} from 'gsap'
import * as MODES from 'src/config/modes'
//import IconClose from 'src/components/vca/widgets/IconClose'
import * as PATHS from 'src/router/paths'
import QRCard from 'src/components/vca/widgets/QRCard'
import Logo from 'src/components/vca/widgets/Logo'
import BgPattern from 'src/components/vca/widgets/BgPattern'
import Waveline from 'src/components/vca/widgets/Waveline'

export default {
  name: "Ending",
  props: {
    prop: {
      default: false,
      required: false,

    }
  },
  components: {
    //IconClose,
    Logo,
    'qr-card': QRCard,
    BgPattern,
    Waveline
  },
  data() {
    return {
      selected: 0,
      showQR: false,
      MODES,
      active: false,
      timeline: 0,
      timeline2: 0
    }
  },
  computed:{
    ...mapState('app', ['gallery', 'mode', 'currSceneIdx', 'sceneComplete']),
  },
  methods: {
    ...mapMutations('app', ['closeGallery', 'addToGallery', 'openQRPage', 'setCurrSceneIdx', 'setMode', 'lockMode', 'unlockMode']),
    init() {


    },
    select(i){
      this.selected = i
    },
    btnFollow(){
      AnalyticsService.sendEvent('ending', 'click', `button-follow`)
      this.openQRPage()
    },
    animateIn(cb) {

      let tl = new TimelineMax({ onComplete: cb})
      this.tl = tl
      //console.log('tltlttlt')

      if (!this.sceneComplete) {
        tl.add('start')
          .set(
            this,
            {
              timeline: 0,
            },
            `start+=0`
          )
          .set(
            this,
            {
              timeline2: 0,
            },
            `start+=0`
          )
          .set(
            this.$refs.btnFollow,
            {
              opacity: 0,
              y: 100
            },
            `start+=0`
          )
          .set(
            this.$refs.btnRestart,
            {
              opacity: 0,
              y:100
            },
            `start+=0`
          )
          .set(
            this.$refs.copy,
            {
              opacity: 0,
              y:100
            },
            `start+=0`
          )
          .to(
            this.$refs.shadow,
            0.7,
            {
              opacity: 1,
              ease: Power2.easeOut
            },
            `start+=0`
          )
          .to(
            this.$refs.btnFollow,
            0.7,
            {
              opacity: 1,
              y:0,
              ease: Back.easeOut.config(3)
            },
            `start+=0.8`
          )
          .to(
            this.$refs.btnRestart,
            0.7,
            {
              opacity: 1,
              y:0,
              ease: Back.easeOut.config(3)
            },
            `start+=0.9`
          )
          .to(
            this,
            0.7,
            {
              timeline: 1,
              ease: Power2.easeOut
            },
            `start+=1.4`
          )
          .to(
            this,
            0.7,
            {
              timeline2: 1,
              ease: Power2.easeOut
            },
            `start+=1.5`
          )
          .to(
            this.$refs.copy,
            0.7,
            {
              opacity: 1,
              y:0,
              ease: Power2.easeOut
            },
            `start+=0.7`
          )
      } else {
        tl.add('start')
          .set(
            this,
            {
              timeline: 0,
            },
            `start+=0`
          )
          .set(
            this,
            {
              timeline2: 0,
            },
            `start+=0`
          )
          .set(
            this.$refs.btnFollow,
            {
              opacity: 0,
              y: 100
            },
            `start+=0`
          )
          .set(
            this.$refs.btnRestart,
            {
              opacity: 0,
              y:100
            },
            `start+=0`
          )
          .to(
            this.$refs.shadow,
            0.7,
            {
              opacity: 1,
              ease: Power2.easeOut
            },
            `start+=0`
          )
          .to(
            this.$refs.btnFollow,
            0.7,
            {
              opacity: 1,
              y:0,
              ease: Back.easeOut.config(3)
            },
            `start+=0.7`
          )
          .to(
            this.$refs.btnRestart,
            0.7,
            {
              opacity: 1,
              y:0,
              ease: Back.easeOut.config(3)
            },
            `start+=0.8`
          )
          .to(
            this,
            0.7,
            {
              timeline: 1,
              ease: Power2.easeOut
            },
            `start+=1.3`
          )
          .to(
            this,
            0.7,
            {
              timeline2: 1,
              ease: Power2.easeOut
            },
            `start+=1.4`
          )
      }

      if (this.$refs.photo1){
        tl.set(
            this.$refs.photo1,
            {
              x: -100,
              opacity: 0
            },
            `start+=0`
          )
          .to(
            this.$refs.photo1,
            0.7,
            {
              x: 0,
              opacity: 1,
              ease: Power2.easeOut
            },
            `start+=0.5`
          )
      }
      if (this.$refs.photo2){
        tl.set(
            this.$refs.photo2,
            {
              x: 100,
              opacity: 0
            },
            `start+=0`
          )
          .to(
            this.$refs.photo2,
            0.7,
            {
              x: 0,
              opacity: 1,
              ease: Power2.easeOut
            },
            `start+=0.6`
          )
      }


    },
    enter(el, done){
      this.lockMode()
      this.animateIn(done)

      //console.log(this.active)
      //this.active = true
      //console.log(this.active)


    },
    animateOut(cb) {

      let tl = new TimelineMax({ onComplete: cb})
      this.tl = tl
      if (!this.sceneComplete) {
        tl.add('start')
          .to(
            this.$refs.shadow,
            0.7,
            {
              opacity: 0,
              ease: Power2.easeOut
            },
            `start+=0`
          )
          .to(
            this.$refs.btnFollow,
            0.7,
            {
              opacity: 0,
              y:100,
              ease: Power2.easeOut
            },
            `start+=0`
          )
          .to(
            this.$refs.btnRestart,
            0.7,
            {
              opacity: 0,
              y:100,
              ease: Power2.easeOut
            },
            `start+=0`
          )
          .to(
            this.$refs.copy,
            0.7,
            {
              opacity: 0,
              y:100,
              ease: Power2.easeOut
            },
            `start+=0`
          )
      } else {
        tl.add('start')
          .to(
            this.$refs.shadow,
            0.7,
            {
              opacity: 0,
              ease: Power2.easeOut
            },
            `start+=0`
          )
          .to(
            this.$refs.btnFollow,
            0.7,
            {
              opacity: 0,
              y: 100,
              ease: Power2.easeOut
            },
            `start+=0`
          )
          .to(
            this.$refs.btnRestart,
            0.7,
            {
              opacity: 0,
              y: 100,
              ease: Power2.easeOut
            },
            `start+=0`
          )
      }

      if (this.$refs.photo1){
        tl.to(
            this.$refs.photo1,
            0.7,
            {
              x: -100,
              opacity: 0,
              ease: Power2.easeOut
            },
            `start+=0`
          )
      }
      if (this.$refs.photo2){
        tl.to(
            this.$refs.photo2,
            0.7,
            {
              x: 100,
              opacity: 0,
              ease: Power2.easeOut
            },
            `start+=0`
          )
      }


    },
    leave(el, done){
      let cb = () => {
        this.unlockMode()
        if (this.currSceneIdx === 4)
          window.MapTitle.animeInOut(4)
        if (this.mode === MODES.KIDS) {
          window.Cam.animateIn()
          window.Bag.animateIntro()
        }
        done()
      }
      //this.tl.eventCallback('onReverseComplete', cb)
      //this.tl.reverse()
      //this.active = false
      this.animateOut(cb)


    },
    openQR(){
      this.showQR = true
      console.log(this.showQR)
    },
    closeQR(){
      this.showQR = false
    },
    replay(){
      //console.log(888, e)
      this.$router.replace({
        name: PATHS.SCENES,
        params:{
          id: this.currSceneIdx
        }
      })
    },
    reset(){
      AnalyticsService.sendEvent('ending', 'click', `button-restart`)
      this.lockMode()
      // if (this.mode === MODES.KIDS) {
      //   window.Cam.animateIn()
      //   window.Bag.animateIntro()
      // }

      let cb = () => {
        window.MapTitle.preventDefault()
        this.setCurrSceneIdx(0)
        this.$emit('endReset')
        this.setMode(0)
        window.GyroView.endRollback()
        this.$router.replace({
          name: PATHS.DESTINATIONS,
        })

        //this.unlockMode()

      }
      //this.tl.eventCallback('onReverseComplete', cb)
      //this.tl.reverse()
      this.animateOut(cb)
    },
    clik(e){
      //console.log(889, e.target)
    }
  },
  mounted() {
    this.init()

    if (this.mode === MODES.KIDS) {
      window.Cam.animateOut()
      window.Bag.animateOut()
    }

    //this.animate()
  },
  beforeDestroy(){

  },
  watch: {

  }
}
</script>


<style lang="sass" scoped>
  @import "src/styles/common.sass"
  .ending
    pointer-events: none
    line-height: 0
    +full()
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    //&.active
      .bg
        .shadow
          opacity: 1
    .bg
      +full()
      //background: $cl-goldy
      display: flex
      justify-content: center
      align-items: center


      .shadow
        width: 100%
        height: 40%
        position: absolute
        background: linear-gradient(357.52deg, rgba(253, 159, 2, 0) 40.3%, #E38203 119.98%)
        top: 0
        left: 0
        z-index: 750
        opacity: 0
        //transition-property: opacity
        //transition-duration: 1s
        //transition-timing-function: ease
        //transition-delay: 0s
      .photos
        width: 75%
        position: relative
        z-index: 700
        .photo
          display: block
          width: 100%
          left: 0
          top: 0
          border: #FFF9EE 0.15rem solid
          border-bottom: #FFF9EE 0.7rem solid
          border-radius: 0.05rem
          //filter: sepia(1)
          transform-origin: center
        .photo-1
          position: relative
          transform: rotateZ(20deg) translate3d(-10%, 20%, 0)
        .photo-2
          position: absolute
          transform: rotateZ(-20deg) translate3d(50%, -20%, 0)



    .copy
      position: relative
      z-index: 750
      color: white
      text-align: center
      line-height: $fs-s*2
      .line-1
        font-size: $fs-m
      .line-2
        font-size: $fs-xl
        margin-bottom: 0.1rem
      .waveline
        position: relative !important
      margin-top: 1rem
      margin-bottom: 0.5rem


    //.btns
      width: 100%
      //display: flex
      //justify-content: center
      //align-items: center
      //flex-direction: column
      z-index: 750
      //height: 1.5rem
      .button

        pointer-events: all
        color: white
        font-size: $fs-s
        line-height: $fs-s*2.5
        background: #3a54a2
        display: flex
        flex-direction: row
        justify-content: center
        align-items: center
        border-radius: $fs-s*1.5
        text-align: center
        margin: 0.25rem auto
        width: 60%
        border: white 2px solid
        svg
          width: $fs-m
          height: $fs-m
          margin-right: 0.1rem
          //background: #e15125
        //background: $cl-blue
        //width: 80%
        //height: 0.5rem
        //margin: 0.05rem auto
        //border-radius: 5px
        //padding: 0.06rem 0
        //text-align: center
        //img

          //background: greenyellow
          display: block
          height: 100%
          margin: auto
          object-fit: cover
        //&:first-child
          margin-top: -0.8rem
    .btns
      width: 100%
      position: relative
      //background: #f8deb1
      //line-height: 0
      //display: flex
      //justify-content: center
      //align-items: center
      //flex-direction: column
      z-index: 750
      //height: 1.5rem
      .button

        pointer-events: all

        //background: #ff55ac
        line-height: 0
        height: $fs-s*2.5
        color: $cl-lightGold
        font-size: $fs-s
        display: flex
        flex-direction: row
        justify-content: center
        align-items: center

        text-align: center
        margin: 0.25rem auto
        //width: 60%
        width: 3rem
        //border: white 2px solid
        .frame
          position: absolute
          top: -10%
          left: 0
        .content
          position: relative
          //background: #3a602e

          .icon
            width: $fs-m
            height: $fs-m
            //background: #e15125
            //margin-right: 0.1rem
          .i-follow
            transform: scale(1.1) translateY(1px)
            transform-origin: center
          .i-replay
            transform: scale(1.25)
            transform-origin: center
          .cp
            position: absolute
            width: $fs-m*5
            top: -$fs-m/2
            left: 0.25rem
            //background: black
            line-height: $fs-m*2
            height: $fs-m*2
            white-space: nowrap
            overflow: hidden


    .qr-container
      +full()
      display: flex
      justify-content: center
      align-items: center
      .qr-card
        margin-top: -0.8rem
    .restart
      pointer-events: all
      z-index: 750
      //position: absolute
      //left: 20%
      //bottom: 1rem
      //background: #E38203
      //font-size: $fs-xl
      //line-height: 2
      //color: $cl-lightGold
    //.restart
      z-index: 750
      position: absolute
      width: 100%
      bottom: 0
      left: 0
      background: #3a54a2
      font-size: $fs-xl
      line-height: 1rem
      height: 1rem
      text-align: center
      color: $cl-lightGold
      overflow: hidden
      //background: linear-gradient(189.5deg, #3859A8 27.25%, #133E8E 99.06%)

      .bg-pattern
        mix-blend-mode: color-burn

  @keyframes fadein
    0%
      opacity: 0
    100%
      opacity: 1

</style>